import api from './request'

const employeeSuggest = (keyword, warehouseId) => {
    return api.getPromise('suggest/employee', {
        keyword,
        warehouseId
    })
}

const cellCodeSuggest = (keyword, warehouseId) => {
    return api.getPromise('suggest/cellCode', {
        keyword,
        warehouseId
    })
}

export default {
    employeeSuggest,
    cellCodeSuggest
}



// WEBPACK FOOTER //
// ./src/request/suggestApi.js